"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SYLIUS = exports.PRO_API = exports.HO_API = exports.ENGINE = exports.DOCUMENTS_API = exports.BILLING = exports.APIS = void 0;
var ENGINE = 'engine';
exports.ENGINE = ENGINE;
var PRO_API = 'pro-api';
exports.PRO_API = PRO_API;
var SYLIUS = 'sylius';
exports.SYLIUS = SYLIUS;
var BILLING = 'billing';
exports.BILLING = BILLING;
var HO_API = 'ho-api';
exports.HO_API = HO_API;
var DOCUMENTS_API = 'documents-api';
exports.DOCUMENTS_API = DOCUMENTS_API;
var APIS = [ENGINE, PRO_API, SYLIUS, BILLING, HO_API, DOCUMENTS_API];
exports.APIS = APIS;